/** Turns a snake_case CDR field name into a readable label for the drawer. */
export function fieldLabel(name: string): string {
  return name
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
    .replace(/\bCfb\b/, "CFB")
    .replace(/\bFe\b/, "");
}

export const CDR_STATUS_LABEL: Record<string, string> = {
  pending: "Pending",
  reviewed_no_issue: "Reviewed – no issue",
  observation: "Observation",
  escalated: "Escalated",
};

export const CDR_STATUS_COLOR: Record<string, string> = {
  pending: "default",
  reviewed_no_issue: "green",
  observation: "gold",
  escalated: "volcano",
};

const FLAG_DETAIL_LABELS: Record<string, string> = {
  instrument: "Instrument",
  instrument_code: "Score code",
  timepoint: "Visit",
  value: "Value",
  change_from_baseline: "Change from baseline",
  threshold: "Threshold",
  threshold_basis: "Threshold basis",
  scale_low: "Scale minimum",
  scale_high: "Scale maximum",
  scale_label: "Scale",
  allowed_values: "Values this scale can take",
  repeated_value: "Repeated value",
  visit_count: "Consecutive visits",
  timepoints: "Visits",
  subject: "Participant",
  site: "Site",
  participants_sharing_value: "Participants sharing this value",
  bound: "Bound",
  bound_value: "Bound value",
  rule: "Rule",
  rule_label: "Rule",
  statement: "Why these cannot both be right",
  violation: "What was found",
  values: "Scores compared",
};

export function flagDetailLabel(key: string): string {
  return FLAG_DETAIL_LABELS[key] ?? fieldLabel(key);
}

export function formatFlagDetailValue(value: unknown): string {
  if (value === null || value === undefined || value === "") return "—";
  if (Array.isArray(value)) return value.join(", ");
  if (typeof value === "object") {
    return Object.entries(value as Record<string, unknown>)
      .map(([key, entry]) => `${key}: ${entry}`)
      .join(" · ");
  }
  if (typeof value === "boolean") return value ? "Yes" : "No";
  return String(value);
}
